// Tokens da tela de Campanhas. Mesma convencao de Propostas.design.js: strings
// Tailwind puras, nivel 1 = regiao da UI, nivel 2 = papel do elemento, e `status`
// como mapa semantico. Consumidores usam `const D = CAMPANHAS_DESIGN`.
import { PLATFORM } from 'src/design/tokens';

export const CAMPANHAS_DESIGN = {
    page: {
        root: 'flex flex-col min-h-full w-full bg-[#f4f4f7] text-[#18181b] animate-in fade-in slide-in-from-bottom-4 duration-500',
        fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
        container: 'w-full px-4 md:px-6 lg:px-8',
        pageBody: 'pb-[120px]',
        stickyHeader: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec]',
        topbar: 'flex flex-col md:flex-row md:items-start gap-4 pt-[18px] pb-[18px]',
        topbarIdentity: 'flex items-start gap-3.5 min-w-0 flex-1',
        iconTile:
            'flex items-center justify-center flex-shrink-0 w-[42px] h-[42px] rounded-[10px] bg-[#ede9fe] text-[#6d28d9]',
        headerTitle: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]',
        headerSubtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5]',
        topbarActions: 'flex items-center gap-2.5 flex-shrink-0 flex-wrap md:pt-[5px]',
        primaryButton:
            'inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-[10px] bg-gradient-to-b from-[#8b5cf6] to-[#7c3aed] text-white text-[14px] font-semibold whitespace-nowrap shadow-[0_2px_8px_rgba(124,58,237,.32)] transition-colors hover:from-[#7c3aed] hover:to-[#6d28d9] disabled:from-[#e4e4e7] disabled:to-[#e4e4e7] disabled:text-[#a1a1aa] disabled:shadow-none disabled:cursor-not-allowed',
        filterBar: 'flex flex-wrap items-end gap-3 mb-3',
        filterItem: 'min-w-0',
        filterLabel: 'text-[10px] font-semibold text-[#a1a1aa] uppercase tracking-wider mb-1 block',
        filterSelect:
            'h-9 w-[150px] md:w-[170px] text-xs rounded-lg border border-[#d4d4d8] bg-white px-3 text-[#18181b] shadow-none hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus:ring-2 focus:ring-[#c4b5fd]',
        filterSearchWrap: 'relative min-w-[180px] w-[200px] md:w-[240px]',
        filterSearch:
            'h-9 w-full pl-9 pr-3 text-xs rounded-lg border border-[#d4d4d8] bg-white text-[#18181b] shadow-none placeholder:text-[#a1a1aa] hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus-visible:ring-2 focus-visible:ring-[#c4b5fd] focus-visible:ring-offset-0',
        searchIcon: 'absolute left-3 top-1/2 -translate-y-1/2 text-[#a1a1aa] pointer-events-none',
        tabsBar: 'flex items-center gap-1 mb-4 border-b border-[#e7e7ec] overflow-x-auto',
        tabBtn: 'flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors whitespace-nowrap',
        tabBtnActive: 'border-[#7C3AED] text-[#7C3AED]',
        tabBtnIdle: 'border-transparent text-[#71717a] hover:text-[#18181b]',
        // legado — evitar quebrar outros consumidores
        containerLegacy: 'h-full overflow-y-auto',
        content: 'max-w-[98%] mx-auto',
        iconBox: 'p-2 bg-[#7C3AED]/10 rounded-lg',
        icon: 'text-[#7C3AED]',
        title: 'text-sm font-semibold text-gray-900 dark:text-[#D1D2D3]',
        actionButton: 'h-9 bg-[#7C3AED] hover:bg-[#6D28D9] text-white font-medium rounded-lg px-4 text-xs',
    },

    stats: {
        grid: 'grid grid-cols-2 md:grid-cols-4 gap-3 mb-4',
        card: 'bg-white dark:bg-[#222529] rounded-xl border border-gray-100 dark:border-[#383838] p-4 flex items-center gap-3',
        iconBox: 'w-10 h-10 rounded-xl flex items-center justify-center bg-violet-50 dark:bg-violet-500/10',
        icon: 'text-violet-600 dark:text-violet-400',
        value: 'text-xl font-bold text-gray-900 dark:text-[#D1D2D3] tabular-nums',
        label: 'text-xs text-gray-500 dark:text-[#ABABAD]'
    },

    // Status da campanha (Campanhas.status_envio).
    status: {
        agendado:       { label: 'Agendada',     bg: 'bg-blue-50 dark:bg-blue-500/10',   text: 'text-blue-700 dark:text-blue-400',   dot: 'bg-blue-500' },
        'em andamento': { label: 'Em andamento', bg: 'bg-amber-50 dark:bg-amber-500/10', text: 'text-amber-700 dark:text-amber-400', dot: 'bg-amber-500 animate-pulse' },
        finalizado:     { label: 'Finalizada',   bg: 'bg-green-50 dark:bg-green-500/10', text: 'text-green-700 dark:text-green-400', dot: 'bg-green-500' },
        erro:           { label: 'Com erro',     bg: 'bg-red-50 dark:bg-red-500/10',     text: 'text-red-700 dark:text-red-400',     dot: 'bg-red-500' }
    },

    // Status por destinatario (CampaignsJobs.status).
    jobStatus: {
        agendado:    { label: 'Agendado',  bg: 'bg-gray-100 dark:bg-gray-500/10',  text: 'text-gray-600 dark:text-gray-400',   dot: 'bg-gray-400' },
        processando: { label: 'Enviando',  bg: 'bg-blue-50 dark:bg-blue-500/10',   text: 'text-blue-700 dark:text-blue-400',   dot: 'bg-blue-500 animate-pulse' },
        enviado:     { label: 'Enviado',   bg: 'bg-green-50 dark:bg-green-500/10', text: 'text-green-700 dark:text-green-400', dot: 'bg-green-500' },
        erro:        { label: 'Falhou',    bg: 'bg-red-50 dark:bg-red-500/10',     text: 'text-red-700 dark:text-red-400',     dot: 'bg-red-500' },
        cancelado:   { label: 'Cancelado', bg: 'bg-gray-100 dark:bg-gray-500/10',  text: 'text-gray-500 dark:text-gray-500',   dot: 'bg-gray-400' }
    },

    // Status cru da Comtele. A lista NAO e exaustiva de proposito — o provider pode
    // introduzir status novos, e quem consome tem que cair no fallback neutro em vez
    // de quebrar. Sempre acessar via `rotuloSmsStatus`.
    smsStatus: {
        Delivered:     { label: 'Entregue',        classe: 'bg-green-50 dark:bg-green-500/10 text-green-700 dark:text-green-400' },
        Read:          { label: 'Lido',            classe: 'bg-green-50 dark:bg-green-500/10 text-green-700 dark:text-green-400' },
        Sent:          { label: 'Enviado',         classe: 'bg-blue-50 dark:bg-blue-500/10 text-blue-700 dark:text-blue-400' },
        Sending:       { label: 'Enviando',        classe: 'bg-blue-50 dark:bg-blue-500/10 text-blue-700 dark:text-blue-400' },
        Queued:        { label: 'Na fila',         classe: 'bg-gray-100 dark:bg-gray-500/10 text-gray-600 dark:text-gray-400' },
        Created:       { label: 'Aceito',          classe: 'bg-gray-100 dark:bg-gray-500/10 text-gray-600 dark:text-gray-400' },
        Processing:    { label: 'Processando',     classe: 'bg-gray-100 dark:bg-gray-500/10 text-gray-600 dark:text-gray-400' },
        Analysis:      { label: 'Em análise',      classe: 'bg-gray-100 dark:bg-gray-500/10 text-gray-600 dark:text-gray-400' },
        Failed:        { label: 'Falhou',          classe: 'bg-red-50 dark:bg-red-500/10 text-red-700 dark:text-red-400' },
        Expired:       { label: 'Expirou',         classe: 'bg-red-50 dark:bg-red-500/10 text-red-700 dark:text-red-400' },
        Invalid:       { label: 'Inválida',        classe: 'bg-red-50 dark:bg-red-500/10 text-red-700 dark:text-red-400' },
        InvalidNumber: { label: 'Número inválido', classe: 'bg-red-50 dark:bg-red-500/10 text-red-700 dark:text-red-400' },
        Rejected:      { label: 'Rejeitada',       classe: 'bg-red-50 dark:bg-red-500/10 text-red-700 dark:text-red-400' },
        Undeliverable: { label: 'Não entregue',    classe: 'bg-red-50 dark:bg-red-500/10 text-red-700 dark:text-red-400' },
        LowBalance:    { label: 'Sem saldo',       classe: 'bg-orange-50 dark:bg-orange-500/10 text-orange-700 dark:text-orange-400' },
        Blocked:       { label: 'Bloqueado',       classe: 'bg-orange-50 dark:bg-orange-500/10 text-orange-700 dark:text-orange-400' },
        LimitExceeded: { label: 'Limite excedido', classe: 'bg-orange-50 dark:bg-orange-500/10 text-orange-700 dark:text-orange-400' },
        Canceled:      { label: 'Cancelada',       classe: 'bg-gray-100 dark:bg-gray-500/10 text-gray-500' }
    },

    progresso: {
        track: 'h-1.5 w-full rounded-full bg-gray-100 dark:bg-[#383838] overflow-hidden flex',
        segEnviado: 'bg-[#7C3AED] h-full transition-all duration-500',
        segErro: 'bg-red-400 h-full transition-all duration-500',
        segCancelado: 'bg-gray-300 dark:bg-gray-600 h-full transition-all duration-500',
        texto: 'text-[11px] text-gray-500 dark:text-[#ABABAD] tabular-nums mt-1',
        percentual: 'font-semibold text-gray-700 dark:text-[#D1D2D3]',
        vazio: 'text-[11px] text-gray-400 dark:text-gray-600 italic'
    },

    // Icone/label vem da fonte unica de plataforma (src/design/tokens) — so a
    // classe visual (chip desta tela especifica) fica local.
    tipoEnvio: {
        whatsapp: { label: PLATFORM.whatsapp.label, icon: PLATFORM.whatsapp.icon, classe: 'bg-green-50 dark:bg-green-500/10 text-green-700 dark:text-green-400' },
        sms: { label: PLATFORM.sms.label, icon: PLATFORM.sms.icon, classe: 'bg-blue-50 dark:bg-blue-500/10 text-blue-700 dark:text-blue-400' }
    },

    tipoPublico: {
        funil:          { label: 'Funil', icon: 'mdi:filter-variant' },
        tag:            { label: 'Tags',  icon: 'mdi:tag-outline' },
        lista_contatos: { label: 'Lista', icon: 'mdi:format-list-bulleted' },
        csv:            { label: 'CSV',   icon: 'mdi:file-delimited-outline' }
    },

    // Pagina dedicada de acompanhamento (dashboard/campanhas/:id).
    // O hero e uma barra de composicao: mesma linguagem da barra da listagem
    // (violeta = enviado), com o verde de "entregue" vindo dos chips de status.
    //
    // Fontes maiores de proposito que os tokens equivalentes da listagem
    // (D.destinatario, D.page): esta pagina e uma tela de leitura unica, nao uma
    // linha densa de tabela repetida centenas de vezes — por isso tem tokens
    // proprios (`titulo`, `dest*`) em vez de reusar os da listagem.
    detalhes: {
        // Fundo proprio (nao D.page.container, que a listagem tambem usa e e
        // transparente): cinza sutil por tras dos cards brancos para dar contraste,
        // mesmo par claro/escuro do corpo do wizard (bg-gray-50/60 / #1A1D21).
        pagina: 'h-full overflow-y-auto bg-gray-50/60 dark:bg-[#1A1D21]',
        voltar: 'p-2 rounded-lg text-gray-400 hover:text-[#7C3AED] hover:bg-violet-50 dark:hover:bg-violet-500/10 transition-colors flex-shrink-0',
        // NAO compor com D.page.content: sao duas utilities max-w-* em conflito e
        // a que vence e a ultima do CSS gerado, nao a do className.
        content: 'max-w-6xl mx-auto px-3 md:px-4 pb-10',
        titulo: 'text-base font-semibold text-gray-900 dark:text-[#D1D2D3]',
        atualizado: 'text-xs text-gray-400 tabular-nums',
        recarregar: 'flex items-center gap-2 h-9 px-3.5 text-xs font-medium rounded-lg border border-gray-200 dark:border-[#383838] bg-white dark:bg-[#222529] text-gray-700 dark:text-[#D1D2D3] hover:bg-gray-50 dark:hover:bg-[#383838] hover:text-[#7C3AED] transition-colors disabled:opacity-50 disabled:pointer-events-none',

        hero: 'bg-white dark:bg-[#222529] rounded-2xl border border-gray-100 dark:border-[#383838] p-5 md:p-6 mb-4 animate-in fade-in slide-in-from-bottom-4 duration-500',
        heroTopo: 'flex flex-wrap items-end justify-between gap-3',
        heroLabel: 'text-xs font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider block mb-1.5',
        heroNumero: 'text-4xl md:text-5xl font-bold text-gray-900 dark:text-[#D1D2D3] tabular-nums leading-none',
        heroNumeroSub: 'text-base font-normal text-gray-400 dark:text-[#ABABAD]',
        heroPct: 'text-sm font-bold text-[#7C3AED] bg-violet-50 dark:bg-violet-500/10 rounded-md px-3 py-1.5 tabular-nums',
        barra: 'mt-5 h-3 w-full rounded-full bg-gray-100 dark:bg-[#1A1D21] overflow-hidden flex',
        barraSegmento: 'h-full transition-all duration-700',
        // Dots quadrados de proposito: ecoam os segmentos retangulares da barra.
        legenda: 'mt-3 flex flex-wrap items-center gap-x-4 gap-y-1.5',
        legendaItem: 'flex items-center gap-1.5 text-sm text-gray-500 dark:text-[#ABABAD]',
        legendaDot: 'w-2 h-2 rounded-sm flex-shrink-0',
        legendaValor: 'font-semibold text-gray-900 dark:text-[#D1D2D3] tabular-nums',
        metaRow: 'mt-4 pt-4 border-t border-gray-100 dark:border-[#383838] flex flex-wrap items-center gap-x-5 gap-y-1 text-sm text-gray-500 dark:text-[#ABABAD]',
        metaForte: 'font-medium text-gray-700 dark:text-[#D1D2D3]',

        // Taxa de entrega (pizza + cards) — espelha o bloco de Consumo.
        taxaCard: 'bg-white dark:bg-[#222529] rounded-2xl border border-gray-100 dark:border-[#383838] p-5 mb-4 animate-in fade-in slide-in-from-bottom-4 duration-500',
        taxaTitulo: 'text-sm font-semibold text-gray-900 dark:text-[#D1D2D3]',
        taxaSub: 'text-xs text-gray-500 dark:text-[#ABABAD] mt-0.5',
        taxaLayout: 'mt-4 flex flex-col md:flex-row gap-4',
        taxaChart: 'w-full md:w-1/2 h-52',
        taxaRates: 'w-full md:w-1/2 grid grid-cols-2 gap-2 content-center',
        taxaRateEnviado: 'text-center p-3 bg-amber-50 dark:bg-amber-500/10 rounded-xl border border-amber-100 dark:border-amber-500/20',
        taxaRateEnviadoValor: 'text-xl font-bold text-amber-600 dark:text-amber-400 tabular-nums',
        taxaRateEnviadoLabel: 'text-[11px] text-amber-700 dark:text-amber-400 font-medium',
        taxaRateEntregue: 'text-center p-3 bg-blue-50 dark:bg-blue-500/10 rounded-xl border border-blue-100 dark:border-blue-500/20',
        taxaRateEntregueValor: 'text-xl font-bold text-blue-600 dark:text-blue-400 tabular-nums',
        taxaRateEntregueLabel: 'text-[11px] text-blue-700 dark:text-blue-400 font-medium',
        taxaRateLido: 'text-center p-3 bg-green-50 dark:bg-green-500/10 rounded-xl border border-green-100 dark:border-green-500/20',
        taxaRateLidoValor: 'text-xl font-bold text-green-600 dark:text-green-400 tabular-nums',
        taxaRateLidoLabel: 'text-[11px] text-green-700 dark:text-green-400 font-medium',
        taxaRateErro: 'text-center p-3 bg-red-50 dark:bg-red-500/10 rounded-xl border border-red-100 dark:border-red-500/20',
        taxaRateErroValor: 'text-xl font-bold text-red-600 dark:text-red-400 tabular-nums',
        taxaRateErroLabel: 'text-[11px] text-red-700 dark:text-red-400 font-medium',

        grid: 'grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_320px] gap-4 items-start',
        card: 'bg-white dark:bg-[#222529] rounded-2xl border border-gray-100 dark:border-[#383838]',
        cardHeader: 'flex flex-wrap items-center justify-between gap-2 px-4 pt-4',
        cardTitulo: 'text-xs font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider',
        cardBadge: 'text-xs font-semibold text-gray-400 tabular-nums',
        cardCorpo: 'px-4 pb-4',

        // Conteudo do disparo (texto livre, template ou anexos).
        mensagemTexto: 'text-sm leading-relaxed text-gray-700 dark:text-[#D1D2D3] whitespace-pre-wrap break-words bg-gray-50 dark:bg-[#1A1D21] rounded-xl p-3.5',
        mensagemTemplateBox: 'flex items-start gap-2.5 bg-violet-50/60 dark:bg-violet-500/10 rounded-xl p-3.5',
        mensagemTemplateNome: 'text-sm font-semibold text-gray-900 dark:text-[#D1D2D3]',
        mensagemTemplateSub: 'text-xs text-gray-500 dark:text-[#ABABAD] mt-0.5',
        anexosLista: 'mt-2.5 flex flex-wrap gap-1.5',
        anexoChip: 'inline-flex items-center gap-1.5 text-xs font-medium text-gray-600 dark:text-[#ABABAD] bg-gray-100 dark:bg-[#1A1D21] rounded-lg px-2.5 py-1.5',

        filtroChip: 'px-3 py-1.5 rounded-md text-xs font-medium transition-colors bg-gray-100 dark:bg-[#1A1D21] text-gray-500 dark:text-[#ABABAD] hover:bg-gray-200 dark:hover:bg-[#383838]',
        filtroChipAtivo: 'px-3 py-1.5 rounded-md text-xs font-medium bg-[#7C3AED] text-white',

        infoLinha: 'flex items-center justify-between gap-3 py-2 text-sm border-b last:border-b-0 border-gray-50 dark:border-[#383838]/40',
        infoLabel: 'text-gray-400 dark:text-gray-500 flex-shrink-0',
        infoValor: 'font-medium text-gray-700 dark:text-[#D1D2D3] text-right truncate',

        timeline: 'space-y-3',
        evento: 'flex items-start gap-2.5',
        eventoIcone: 'w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0',
        eventoTitulo: 'text-sm font-medium text-gray-900 dark:text-[#D1D2D3]',
        eventoMeta: 'text-xs text-gray-500 dark:text-[#ABABAD] leading-relaxed',

        // Lista de destinatarios: tokens proprios (nao D.destinatario, que a
        // listagem tambem usa) para poder crescer aqui sem mexer na tabela.
        destLinha: 'group flex items-start gap-3 py-2.5 border-b last:border-b-0 border-gray-100 dark:border-[#383838]/60',
        destNome: 'text-sm font-medium text-gray-900 dark:text-[#D1D2D3] truncate',
        destNumero: 'text-xs text-gray-500 dark:text-[#ABABAD] tabular-nums',
        destChip: 'inline-flex items-center px-2 py-1 rounded text-[10px] font-semibold uppercase tracking-wider whitespace-nowrap',
        destChipRespondido: 'inline-flex items-center gap-1 px-2 py-1 rounded text-[10px] font-semibold uppercase tracking-wider whitespace-nowrap bg-blue-50 dark:bg-blue-500/10 text-blue-700 dark:text-blue-400',
        destErro: 'text-xs text-red-600 dark:text-red-400 mt-0.5 break-words',
        destHistorico: 'mt-1.5 ml-1 pl-2.5 border-l border-gray-200 dark:border-[#383838] space-y-1',
        destHistoricoItem: 'text-xs text-gray-500 dark:text-[#ABABAD] tabular-nums',
        destAcao: 'p-1.5 rounded-lg text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10 transition-colors opacity-0 group-hover:opacity-100 flex-shrink-0',
        destCarregarMais: 'w-full mt-2 py-2.5 text-sm font-medium text-[#7C3AED] hover:bg-violet-50 dark:hover:bg-violet-500/10 rounded-lg transition-colors',

        vazio: 'flex flex-col items-center justify-center py-8 text-center',
        vazioTexto: 'text-sm text-gray-400 dark:text-gray-500 mt-1.5'
    },

    // Card condicional de destaque (so aparece quando ha falhas), equivalente ao
    // AssinaturaCard de Propostas.
    alertaErro: {
        card: 'bg-white dark:bg-[#222529] rounded-xl border border-red-100 dark:border-red-500/20 p-4',
        header: 'flex items-center gap-2 mb-2',
        headerIcon: 'w-7 h-7 rounded-lg bg-red-50 dark:bg-red-500/10 flex items-center justify-center text-red-600 dark:text-red-400 flex-shrink-0',
        headerTitle: 'text-sm font-bold text-gray-900 dark:text-[#D1D2D3]',
        headerSub: 'text-xs text-gray-500 dark:text-[#ABABAD]',
        item: 'text-xs text-gray-600 dark:text-[#ABABAD] truncate py-0.5'
    },

    destinatario: {
        linha: 'group flex items-start gap-2 py-2 border-b last:border-b-0 border-gray-100 dark:border-[#383838]/60',
        nome: 'text-xs font-medium text-gray-900 dark:text-[#D1D2D3] truncate',
        numero: 'text-[10px] text-gray-500 dark:text-[#ABABAD] tabular-nums',
        chip: 'inline-flex items-center px-1.5 py-0.5 rounded text-[9px] font-semibold uppercase tracking-wider whitespace-nowrap',
        erro: 'text-[10px] text-red-600 dark:text-red-400 mt-0.5 break-words',
        historico: 'mt-1.5 ml-1 pl-2.5 border-l border-gray-200 dark:border-[#383838] space-y-1',
        historicoItem: 'text-[10px] text-gray-500 dark:text-[#ABABAD] tabular-nums',
        acao: 'p-1.5 rounded-lg text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10 transition-colors opacity-0 group-hover:opacity-100 flex-shrink-0',
        carregarMais: 'w-full mt-2 py-2 text-[11px] font-medium text-[#7C3AED] hover:bg-violet-50 dark:hover:bg-violet-500/10 rounded-lg transition-colors'
    },

    wizard: {
        dialog: 'max-w-4xl w-[94vw] h-[88vh] p-0 gap-0 overflow-hidden flex flex-col rounded-2xl',
        header: 'px-6 py-4 border-b border-gray-100 dark:border-[#383838] flex-shrink-0',
        corpo: 'flex-1 min-h-0 overflow-y-auto px-6 py-5 bg-gray-50/60 dark:bg-[#1A1D21]',
        footer: 'flex items-center justify-between gap-3 px-6 py-4 border-t border-gray-100 dark:border-[#383838] bg-gray-50/80 dark:bg-[#1A1D21]/80 flex-shrink-0',
        stepper: 'flex items-center gap-2 flex-1',
        stepAtivo: 'w-7 h-7 rounded-full bg-[#7C3AED] text-white text-[11px] font-bold flex items-center justify-center flex-shrink-0',
        stepFeito: 'w-7 h-7 rounded-full bg-violet-100 dark:bg-violet-500/20 text-[#7C3AED] text-[11px] font-bold flex items-center justify-center flex-shrink-0',
        stepInativo: 'w-7 h-7 rounded-full bg-gray-100 dark:bg-[#383838] text-gray-400 text-[11px] font-bold flex items-center justify-center flex-shrink-0',
        stepLinha: 'h-px flex-1 bg-gray-200 dark:bg-[#383838] min-w-[12px]',
        stepLabel: 'text-xs font-medium text-gray-900 dark:text-[#D1D2D3]',
        stepSub: 'text-[10px] text-gray-400',
        secao: 'bg-white dark:bg-[#222529] rounded-xl border border-gray-100 dark:border-[#383838] p-5',
        secaoTitulo: 'text-sm font-bold text-gray-900 dark:text-[#D1D2D3]',
        secaoSub: 'text-xs text-gray-500 dark:text-[#ABABAD] mt-0.5',
        label: 'text-[10px] font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider mb-1 block',
        input: 'border-gray-200 dark:border-[#383838] focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl',
        cardOpcao: 'flex items-start gap-3 p-4 rounded-xl border-2 text-left transition-all border-gray-200 dark:border-[#383838] hover:border-violet-300 dark:hover:border-violet-500/40 bg-white dark:bg-[#222529]',
        cardOpcaoAtiva: 'flex items-start gap-3 p-4 rounded-xl border-2 text-left transition-all border-[#7C3AED] bg-violet-50/60 dark:bg-violet-500/10',
        cardOpcaoDesabilitada: 'flex items-start gap-3 p-4 rounded-xl border-2 text-left border-gray-100 dark:border-[#383838] bg-gray-50 dark:bg-[#1A1D21] opacity-60 cursor-not-allowed',
        cardIcone: 'w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0',
        avisoInfo: 'flex items-start gap-2 p-3 rounded-xl bg-violet-50 dark:bg-violet-500/10 border border-violet-100 dark:border-violet-500/20 text-[11px] text-violet-800 dark:text-violet-300',
        avisoAlerta: 'flex items-start gap-2 p-3 rounded-xl bg-amber-50 dark:bg-amber-500/10 border border-amber-100 dark:border-amber-500/20 text-[11px] text-amber-800 dark:text-amber-300',
        avisoErro: 'flex items-start gap-2 p-3 rounded-xl bg-red-50 dark:bg-red-500/10 border border-red-100 dark:border-red-500/20 text-[11px] text-red-800 dark:text-red-300'
    },

    estado: {
        loadingCard: 'bg-white dark:bg-[#222529] rounded-2xl border border-gray-100 dark:border-[#383838] shadow-sm overflow-hidden',
        loadingBox: 'flex flex-col items-center justify-center h-64 text-gray-400 dark:text-[#ABABAD]',
        loadingTexto: 'text-sm font-medium',
        vazioBox: 'flex flex-col items-center justify-center h-72 text-center px-6',
        vazioIcone: 'w-16 h-16 rounded-full bg-violet-50 dark:bg-violet-500/10 flex items-center justify-center mb-4',
        vazioTitulo: 'text-base font-bold text-gray-900 dark:text-[#D1D2D3]',
        vazioTexto: 'text-sm text-gray-500 dark:text-[#ABABAD] max-w-sm mt-1'
    }
};

/** Fallback obrigatorio: a Comtele pode mandar status que ainda nao mapeamos. */
export const rotuloSmsStatus = (raw) => {
    if (!raw) return null;
    return (
        CAMPANHAS_DESIGN.smsStatus[raw] || {
            label: raw,
            classe: 'bg-gray-100 dark:bg-gray-500/10 text-gray-600 dark:text-gray-400'
        }
    );
};

const STATUS_LABEL_KEYS = {
    agendado: 'campaigns.statusLabels.scheduled',
    'em andamento': 'campaigns.statusLabels.inProgress',
    finalizado: 'campaigns.statusLabels.finished',
    erro: 'campaigns.statusLabels.error'
};

/** Config de status com fallback, para nunca renderizar undefined. */
export const configStatusCampanha = (status, t) => {
    const cfg = CAMPANHAS_DESIGN.status[status] || CAMPANHAS_DESIGN.status.agendado;
    if (!t) return cfg;
    const key = STATUS_LABEL_KEYS[status] || STATUS_LABEL_KEYS.agendado;
    return { ...cfg, label: t(key) };
};

export const configStatusJob = (status) =>
    CAMPANHAS_DESIGN.jobStatus[status] || CAMPANHAS_DESIGN.jobStatus.agendado;

const TIPO_ENVIO_LABEL_KEYS = {
    whatsapp: 'campaigns.filters.whatsapp',
    sms: 'campaigns.filters.sms'
};

export const configTipoEnvio = (tipo, t) => {
    const cfg = CAMPANHAS_DESIGN.tipoEnvio[tipo] || CAMPANHAS_DESIGN.tipoEnvio.whatsapp;
    if (!t) return cfg;
    const key = TIPO_ENVIO_LABEL_KEYS[tipo] || TIPO_ENVIO_LABEL_KEYS.whatsapp;
    return { ...cfg, label: t(key) };
};

const TIPO_PUBLICO_LABEL_KEYS = {
    funil: 'campaigns.audienceType.funnel',
    tag: 'campaigns.audienceType.tags',
    lista_contatos: 'campaigns.audienceType.list',
    csv: 'campaigns.audienceType.csv'
};

export const configTipoPublico = (tipo, t) => {
    const cfg = CAMPANHAS_DESIGN.tipoPublico[tipo];
    if (!cfg) return null;
    if (!t) return cfg;
    const key = TIPO_PUBLICO_LABEL_KEYS[tipo];
    return key ? { ...cfg, label: t(key) } : cfg;
};
